const filterEmptyValues = (obj: Record<string, any>): Record<string, any> => {
  const filtered: Record<string, any> = {}

  if (!obj) {
    return filtered
  }

  Object.entries(obj).forEach(([key, value]) => {
    if (
      key !== '' &&
      key !== undefined &&
      key !== null &&
      value !== null &&
      value !== undefined &&
      !(
        value === '' ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === 'object' && Object.keys(value).length === 0)
      )
    ) {
      filtered[key] = value
    }

    if (
      typeof value === 'object' &&
      Object.keys(value).length > 0 &&
      !Array.isArray(value)
    ) {
      filtered[key] = filterEmptyValues(value)
    }
  })

  return filtered
}

export { filterEmptyValues }
